"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAuth = void 0;

var _react = require("react");

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // https://medium.com/@ryanchenkie_40935/react-authentication-how-to-store-jwt-in-a-cookie-346519310e81
// https://hasura.io/blog/best-practices-of-using-jwt-with-graphql/


var useAuth = function useAuth() {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isAuthenticated = _useState2[0],
      setIsAuthenticated = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      hasCheckedAuthenticationStatus = _useState4[0],
      setHasCheckedAuthenticationStatus = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      loginError = _useState6[0],
      setLoginError = _useState6[1];

  var logout = function logout() {
    setIsAuthenticated(false);

    _axios["default"].post('/user/logout').then(function (response) {
      console.log('Logout response', response);
      checkLoginStatus();
    });
  };

  var checkLoginStatus = function checkLoginStatus(callback) {
    return _axios["default"].get('/status').then(function (response) {
      if (response) {
        setIsAuthenticated(true);
        setHasCheckedAuthenticationStatus(true);
      }

      if (callback) {
        callback();
      }
    })["catch"](function () {
      console.log('Not logged in');
      setHasCheckedAuthenticationStatus(true);

      if (callback) {
        callback();
      }
    });
  };

  (0, _react.useEffect)(function () {
    _axios["default"].interceptors.response.use(undefined, function (err) {
      var error = err.response;
      var hasError = error && error.config && !error.config.__isRetryRequest;

      if (hasError && error.status === 401) {
        if (isAuthenticated) {
          console.log('Unauthorized, logging out');
          logout();
        }
      }

      if (hasError && error.status === 403) {
        console.log('Incorrect CSRF token, sod off'); // logout();
      }

      if (hasError && error.status > 400) {
        console.log('Error', error); // logout();
      }

      throw error; // return Promise.reject(error);
    });
  }, []);
  return {
    isAuthenticated: isAuthenticated,
    login: function login(_ref) {
      var email = _ref.email,
          password = _ref.password;
      return _axios["default"].post('/user/login', {
        email: email,
        password: password
      }, {
        withCredentials: false
      }).then(function (response) {
        console.log('Login response', response);

        if (response) {
          setIsAuthenticated(true);
        } // console.log(data);
        // if (data && data.length) {
        // }

      });
    },
    signup: function signup(_ref2) {
      var email = _ref2.email,
          password = _ref2.password,
          name = _ref2.name,
          organizationName = _ref2.organizationName;
      return _axios["default"].post('/user/register', {
        email: email,
        password: password,
        name: name,
        organizationName: organizationName
      }, {
        withCredentials: false
      }).then(function (response) {
        console.log('Signup response', response);

        if (response) {
          setIsAuthenticated(true);
        } // console.log(data);
        // if (data && data.length) {
        // }

      });
    },
    logout: logout,
    loginError: loginError,
    checkLoginStatus: checkLoginStatus,
    hasCheckedAuthenticationStatus: hasCheckedAuthenticationStatus,
    confirmInvitation: function confirmInvitation(_ref3) {
      var token = _ref3.token;
      return _axios["default"].put("/team/invite/confirm/".concat(token));
    },
    declineInvitation: function declineInvitation(_ref4) {
      var token = _ref4.token;
      return _axios["default"].put("/team/invite/decline/".concat(token));
    }
  };
};

exports.useAuth = useAuth;